module.exports = __webpack_public_path__ + "img/TC-logo1.00ea42bf.png";